var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isProduce)?_c('div',[(_vm.order.apply_main_finish)?_c('success-icon',{attrs:{"slot":"reference","text":"完成"},slot:"reference"}):_c('danger-icon',{attrs:{"text":"否"}})],1):_c('div',[_c('no-related-icon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }